/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![DoorExitIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABh0lEQVR4nO2VTUoDUQyAR0RdK1YEFReCF3DpUhdDOy/JFNLE6ron8OcCgnXhwqVH0BuoC9HiAVTQtWBBEN25kIKV12lxajudsbYIYuAxJIR8SSZ5z3H+jBQKhSGDugOkD0BaTXIMSRlIi8w8HAuwjkkDQ+spJgDIY7cAQ1JOUkHNGVFmDMoWkN5/B5IY0NCZeRAgtwyoR0Ba6TkgLL6/Om1Qt/sGaMg/oPorLTKkl4BS6gQwqG9dAyBkDwWteCjrLnPK99cm0tn8bE8BBnUzNmBiAErJkF6EfWzWgS67gHrseSvjUW39NKI+17LL5hbjkvDrAEN6GtjkyrarY7IGda/RXyA9yGR4KgoAJBtWt0ENyXW9bbdp5slIgOu6IwZlP3TvvNprOJPJj7YBPDmOM/AVAih3FtJxdIlkHlAOgfS9HuzF/lQimWtUyMxjTckxpwD1JoDUv3G7QZRfAJST1rtfz9r5N1WSdPmseChLhvTctswGD898bVp+st1xYkcx+pULRrvv8gHBgtMkwozuQQAAAABJRU5ErkJggg==)
 */
export const DoorExitIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9 12a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2.75 3.02A3 3 0 0 1 5 2h10a3 3 0 0 1 3 3v7.64c0 .44-.55.7-.95.55a3 3 0 0 0-3.17 4.93l.02.03a.5.5 0 0 1-.35.85h-.05a.5.5 0 0 0-.5.5 2.5 2.5 0 0 1-3.68 2.2l-5.8-3.09A3 3 0 0 1 2 16V5a3 3 0 0 1 .76-1.98Zm1.3 1.95A.04.04 0 0 0 4 5v11c0 .36.2.68.49.86l5.77 3.08a.5.5 0 0 0 .74-.44V8.02a.5.5 0 0 0-.32-.46l-6.63-2.6Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.3 16.7a1 1 0 0 1 1.4-1.4l4.3 4.29V16a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h3.59l-4.3-4.3Z"
        className={colorClass}
      />
    </svg>
  );
};
